import { Button, Flex } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useCallback } from "react";

import { useCreateMessageTemplate } from "../../api/hooks/deskCollection/messageTemplate/useCreateMessageTemplate.ts";
import { useMessageTemplates } from "../../api/hooks/deskCollection/messageTemplate/useMessageTemplates.ts";
import SvgPlus from "../../components/Icons/Plus.tsx";
import Layout from "../../components/Layout/Layout.tsx";
import NoDataMessage from "../../components/NoDataMessage/NoDataMessage.tsx";
import Preloader from "../../components/Preloader/Preloader.tsx";
import Title from "../../components/Title/Title.tsx";
import {
  CreateDeskCollectionMessageTemplateInput,
  OrderBy,
} from "../../graphql/generated.ts";
import { useMutationNotificationWrapper } from "../../hooks/useMutationNotificationWrapper.tsx";
import { MessageTemplateItem } from "./MessageTemplateItem.tsx";
import { MessageTemplateModal } from "./MessageTemplateModal.tsx";

const MessageTemplatePage = () => {
  const [{ data: templatesResponse, fetching: fetchingTemplates }, refresh] =
    useMessageTemplates({
      orderBy: {
        createdAt: OrderBy.Desc,
      },
    });
  const templates = templatesResponse?.messageTemplates || [];

  const [, createTemplate] = useMutationNotificationWrapper(
    useCreateMessageTemplate(),
    {
      success: {
        message: "Message Template has been successfully created",
      },
    }
  );

  const [
    createModalOpened,
    { open: createModalOpen, close: createModalClose },
  ] = useDisclosure(false);

  const handleCreateTemplate = useCallback(
    (input: CreateDeskCollectionMessageTemplateInput) => {
      createTemplate({ input }).then((data) => {
        if (!data.error) {
          refresh();
        }
      });
    },
    [createTemplate, refresh]
  );

  return (
    <>
      <Layout>
        <Preloader loading={fetchingTemplates} />
        <Flex direction="column" gap={{ base: 16, sm: 24 }}>
          <Flex direction="column" gap={16}>
            <Title size="h1">Message Template</Title>
          </Flex>
          <Button
            uppercase
            variant="filledGolden"
            leftIcon={<SvgPlus />}
            onClick={createModalOpen}
          >
            Add
          </Button>
          {!templates.length && <NoDataMessage />}
          {templates.map((template) => (
            <MessageTemplateItem
              key={template.id}
              template={template}
              refresh={refresh}
            />
          ))}
        </Flex>
        {createModalOpened && (
          <MessageTemplateModal
            opened={true}
            onClose={createModalClose}
            onSubmit={handleCreateTemplate}
          />
        )}
      </Layout>
    </>
  );
};

export default MessageTemplatePage;
